"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = _interopRequireDefault(require("./styles"));
var _TextField = _interopRequireDefault(require("../TextField/TextField"));
var _pickers = require("@material-ui/pickers");
var _TextField2 = _interopRequireDefault(require("@material-ui/core/TextField"));
var _excluded = ["dateValue", "onDateChange", "styleVariant", "minDate", "maxDate", "disablePast", "label"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var DatePicker = props => {
  var classes = (0, _styles.default)(props);
  var {
      dateValue,
      onDateChange,
      styleVariant,
      minDate,
      maxDate,
      disablePast,
      label
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, styleVariant === 'standard' ? /*#__PURE__*/_react.default.createElement(_pickers.DatePicker, _extends({}, rest, {
    disablePast: disablePast,
    label: label,
    value: dateValue,
    minDate: minDate,
    maxDate: maxDate,
    onChange: onDateChange,
    TextFieldComponent: _TextField.default,
    format: "MM/DD/YYYY",
    variant: 'dialog',
    className: classes.container
  })) : /*#__PURE__*/_react.default.createElement(_pickers.DatePicker, _extends({}, rest, {
    disablePast: disablePast,
    label: label,
    value: dateValue,
    minDate: minDate,
    maxDate: maxDate,
    onChange: onDateChange,
    InputProps: {
      inputComponent: () => /*#__PURE__*/_react.default.createElement(_TextField2.default, {
        variant: 'outlined',
        value: dateValue.format('MM/DD/YYYY')
      }),
      disableUnderline: true
    },
    InputLabelProps: {
      shrink: true
    },
    format: "MM/DD/YYYY",
    variant: 'dialog',
    className: classes.container
  })));
};
DatePicker.defaultProps = {
  disablePast: true,
  label: 'Date',
  styleVariant: 'standard'
};
var _default = exports.default = DatePicker;